import React, { Component } from "react";
import { FiCamera } from "react-icons/fi";
import ReactImageUploading from "react-images-uploading";
import Resizer from "react-image-file-resizer";
import { create_media } from "../services";

class UploadImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      shopUid: window.location.pathname.split("/")[2],
    };
  }

  resizeImage(imageList) {
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        imageList[0].file,
        1500,
        1500,
        "JPEG",
        100,
        0,
        (uri) => {
          const formData = new FormData();
          formData.append("file", uri);
          formData.append("location", this.state.shopUid);
          create_media(formData).then((items) => {
            if (items) {
              var new_images = this.props.images;
              new_images.push(items);
              this.props.updateImages(new_images);
            }
          });
        },
        "file"
      );
    });
  }

  render() {
    return (
      <ReactImageUploading
        multiple={false}
        value={this.props.images}
        onChange={(imageList, addUpdateIndex) => this.resizeImage(imageList)}
        maxNumber={20}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <div
            onClick={onImageUpload}
            className="col-12 px-0 text-start"
            style={{ marginTop: "-25px", zIndex: "999" }}
          >
            <div
              className="rounded-circle row mx-0 nav-bottom-grad d-inline-block"
              style={{
                height: "65px",
                width: "65px",
              }}
            >
              <div
                className="col align-self-center"
                style={{ padding: "18px" }}
              >
                <FiCamera className="text-white w-100 h-100" />
              </div>
            </div>
          </div>
        )}
      </ReactImageUploading>
    );
  }
}

export default UploadImage;
